import React from "react";
import { Navigate } from "react-router-dom";

// Ye check karega agar user logged in hai ya nahi
// Tumhare case mein, "isAuthenticated" ko apne login logic ke hisaab se replace karo
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("authToken"); // ya koi bhi login flag

  if (!isAuthenticated) {
    // Agar logged in nahi hai to login page par redirect karo
    return <Navigate to="/" replace />;
  }

  // Agar logged in hai to children component render karo
  return children;
};

export default ProtectedRoute;
